export default {
  data () {
    return {
      codeStatus: 0,
      codeTime: 0
    }
  },
  methods: {
    async handleCode (phone) {
      this.blurInput()
      if (this.codeTime) {
        return
      }
      if (!/^(?:(?:\+|00)86)?1[3-9]\d{9}$/.test(phone)) {
        this.$toast('请输入正确的手机号')
        return
      }
      this.$stat({
        event: 'click_write_code'
      })
      const loading = this.$toast.loading({
        message: '发送中...',
        forbidClick: true
      })
      this.codeStatus = 1
      await this.$fetch.post('/sms/codes', {
        phone,
        app_id: window.$inrice.appID
      })
      loading.clear()
      this.codeTime = 60
      const codeTimer = setInterval(() => {
        if (--this.codeTime === 0) {
          clearInterval(codeTimer)
        }
      }, 1000)
    },
    blurInput () {
      // 如果设备类型为iOS 12+ 和wechat 6.7.4+，恢复成原来的视口
      const timer = setTimeout(() => {
        const version = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/)
        if (version && +version[1] >= 12) {
          const scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0
          window.scrollTo(0, Math.max(scrollHeight - 1, 0))
          clearTimeout(timer)
        }
      }, 100)
    }
  }
}
